import React, { useContext } from 'react';
import style from './style.module.scss';
import cn from 'classnames';

import { CommentsContext } from '../../../context/CommentsContext';

function Emoji() {
  const { emojiBoxActive, setEmojiBoxActive, setInput } = useContext(CommentsContext);

  function handleClick(e) {
    setInput(val => val + e.target.textContent);
  }

  return (
    <>
      <div className={cn(style.emojiBox, { [style.active]: emojiBoxActive })}>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😀
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😄
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😁
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😆
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🥹
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😅
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😂
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤣
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🥲
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😊
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🙂
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🙃
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😉
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😌
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😍
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🥰
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😘
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😋
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😜
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤪
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤨
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🧐
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😎
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤩
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🥳
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😏
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😒
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😞
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😔
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😟
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🥺
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😢
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😭
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😠
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😡
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤬
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤯
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😳
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😱
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😨
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤗
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤔
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🫣
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤭
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🫠
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😬
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🙄
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😯
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤠
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          😷
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤒
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤡
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          ❤️
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          💔
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🩷
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🧡
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          💛
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          💚
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🩵
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          💙
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          💜
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🖤
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🩶
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤍
        </span>
        <span
          className={style.emoji}
          onClick={e => handleClick(e)}
        >
          🤎
        </span>
      </div>
      <span
        className={style.iconTrigger}
        onClick={e => setEmojiBoxActive(val => !val)}
      ></span>
    </>
  );
}

export default Emoji;
